import { Component, Input } from '@angular/core';

/**
 * Cabecera unificada de las secciones de perfil (icono + título + subtítulo, con un
 * botón/acción opcional a la derecha). Cada sección proyecta su propio icono
 * (atributo `headerIcon`) y su propio botón (atributo `headerActions`), conservando
 * sus textos, imágenes y botones; el diseño (caja del icono, tipografías, layout) es común.
 *
 * @author Inetum
 */
@Component({
    selector: 'app-profile-section-header',
    templateUrl: './profile-section-header.component.html',
    styleUrls: ['./profile-section-header.component.scss']
})
export class ProfileSectionHeaderComponent {

    @Input() title: string = '';
    @Input() subtitle: string = '';
    // Permite ocultar la caja del icono en secciones que no tienen imagen propia.
    @Input() showIcon: boolean = true;

}
